// Scorecard rules for automation
export const SCORECARD_RULES = [
  {
    label: 'Team',
    description: 'Select teams',
    uid: 'team_selection',
    operators: ['in', 'not_in'],
    field_type: 'multi_select',
    django_field_type: 'fk',
    is_required: false,
    option_choices: null,
    default_value: null,
    validation_info: {
      has_uuids_as_values: true,
      model_app_label: 'teams',
      model_name: 'Team'
    },
    ui_extract_class: 'av_rule.api.AvomaRuleUiApi',
    ui_data_resolver_method: 'get_teams',
    evaluator_extract_class: 'av_rule.api.AVMeetingRuleEvaluatorApi',
    evaluator_method: 'evaluate_teams_by_uuid',
    api_url: 'av_rules/get_teams',
    order: 1,
    filter_data: {
      Meeting: {
        field_lookup: null,
        filter_class_path: 'av_rule.filters.custom_filters.TeamRuleFilter',
        pg_supported: false
      },
      Call: {
        field_lookup: null,
        filter_class_path: 'av_rule.filters.custom_filters.TeamRuleFilter',
        pg_supported: false
      },
      Conversation: {
        field_lookup: null,
        filter_class_path: 'av_rule.filters.custom_filters.TeamRuleFilter',
        pg_supported: false
      },
      Deal: {
        field_lookup: null,
        filter_class_path: 'av_rule.filters.custom_filters.TeamRuleFilter',
        pg_supported: true
      }
    }
  },
  {
    label: 'Member',
    description: 'Select members',
    uid: 'member_selection',
    operators: ['in', 'not_in'],
    field_type: 'multi_select',
    django_field_type: 'fk',
    is_required: false,
    option_choices: null,
    default_value: null,
    ui_extract_class: 'av_rule.api.AvomaRuleUiApi',
    ui_data_resolver_method: 'get_org_users',
    evaluator_extract_class: 'av_rule.api.AVMeetingRuleEvaluatorApi',
    evaluator_method: 'evaluate_users_by_email',
    api_url: 'av_rules/get_org_users',
    order: 2,
    filter_data: {
      Meeting: {
        field_lookup: null,
        filter_class_path:
          'av_rule.filters.custom_filters.MeetingParticipantRuleFilter',
        pg_supported: true
      },
      Call: {
        field_lookup: null,
        filter_class_path:
          'av_rule.filters.custom_filters.MeetingParticipantRuleFilter',
        pg_supported: true
      },
      Conversation: {
        field_lookup: null,
        filter_class_path:
          'av_rule.filters.custom_filters.MeetingParticipantRuleFilter',
        pg_supported: true
      }
    }
  },
  {
    label: 'Purpose',
    description: 'Purpose',
    uid: 'meeting_purpose',
    operators: ['in', 'not_in'],
    field_type: 'multi_select',
    django_field_type: 'fk',
    is_required: false,
    option_choices: null,
    default_value: null,
    validation_info: {
      has_uuids_as_values: true,
      model_app_label: 'meeting_type',
      model_name: 'MeetingType'
    },
    ui_extract_class: 'av_rule.api.AvomaRuleUiApi',
    ui_data_resolver_method: 'get_meeting_purpose',
    evaluator_extract_class: 'av_rule.api.AVMeetingRuleEvaluatorApi',
    evaluator_method: 'evaluate_meeting_purpose_by_uuid',
    api_url: 'av_rules/get_meeting_purpose',
    order: 5,
    filter_data: {
      Meeting: {
        field_lookup: 'meetingtotype__meeting_type__uuid',
        filter_class_path: null,
        pg_supported: false
      },
      Call: {
        field_lookup: 'meetingtotype__meeting_type__uuid',
        filter_class_path: null,
        pg_supported: false
      },
      Conversation: {
        field_lookup: 'meetingtotype__meeting_type__uuid',
        filter_class_path: null,
        pg_supported: false
      }
    }
  },
  {
    label: 'Outcome',
    description: 'Outcome',
    uid: 'meeting_outcome',
    operators: ['in', 'not_in'],
    field_type: 'multi_select',
    django_field_type: 'fk',
    is_required: false,
    option_choices: null,
    default_value: null,
    validation_info: {
      has_uuids_as_values: true,
      model_app_label: 'meeting_outcome',
      model_name: 'MeetingOutcome'
    },
    ui_extract_class: 'av_rule.api.AvomaRuleUiApi',
    ui_data_resolver_method: 'get_meeting_outcome',
    evaluator_extract_class: 'av_rule.api.AVMeetingRuleEvaluatorApi',
    evaluator_method: 'evaluate_meeting_outcome_by_uuid',
    api_url: 'av_rules/get_meeting_outcome',
    order: 6,
    filter_data: {
      Meeting: {
        field_lookup: 'meetingtooutcome__meeting_outcome__uuid',
        filter_class_path: null,
        pg_supported: false
      },
      Call: {
        field_lookup: 'meetingtooutcome__meeting_type__uuid',
        filter_class_path: null,
        pg_supported: false
      },
      Conversation: {
        field_lookup: 'meetingtooutcome__meeting_type__uuid',
        filter_class_path: null,
        pg_supported: false
      }
    }
  },
  {
    label: 'Conversation type',
    description: 'Conversation type',
    uid: 'is_call',
    operators: ['equal'],
    field_type: 'string',
    django_field_type: 'boolean',
    is_required: false,
    option_choices: {
      false: 'Meeting',
      true: 'Call'
    },
    default_value: null,
    ui_extract_class: null,
    ui_data_resolver_method: null,
    evaluator_extract_class: 'av_rule.api.AVMeetingRuleEvaluatorApi',
    evaluator_method: 'evaluate_is_call',
    api_url: null,
    order: 3,
    filter_data: {
      Meeting: {
        field_lookup: null,
        filter_class_path: 'av_rule.filters.custom_filters.IsCallFilter',
        pg_supported: true
      },
      Call: {
        field_lookup: null,
        filter_class_path: 'av_rule.filters.custom_filters.IsCallFilter',
        pg_supported: true
      },
      Conversation: {
        field_lookup: null,
        filter_class_path: 'av_rule.filters.custom_filters.IsCallFilter',
        pg_supported: true
      }
    }
  },
  {
    label: 'Call type',
    description: 'Call type',
    uid: 'call_direction',
    operators: ['equal'],
    field_type: 'string',
    django_field_type: 'string',
    is_required: false,
    option_choices: {
      inbound: 'Inbound',
      outbound: 'Outbound'
    },
    default_value: null,
    ui_extract_class: null,
    ui_data_resolver_method: null,
    evaluator_extract_class: 'av_rule.api.AVMeetingRuleEvaluatorApi',
    evaluator_method: 'evaluate_call_direction',
    api_url: null,
    order: 4,
    filter_data: {
      Meeting: {
        field_lookup: null,
        filter_class_path: 'av_rule.filters.custom_filters.CallDirectionFilter',
        pg_supported: true
      },
      Call: {
        field_lookup: null,
        filter_class_path: 'av_rule.filters.custom_filters.CallDirectionFilter',
        pg_supported: true
      },
      Conversation: {
        field_lookup: null,
        filter_class_path: 'av_rule.filters.custom_filters.CallDirectionFilter',
        pg_supported: true
      }
    }
  },
  {
    label: 'Meeting duration',
    description: 'Meeting duration',
    uid: 'recording_duration',
    operators: ['gt', 'lt', 'gte', 'lte'],
    field_type: 'number',
    django_field_type: 'number',
    is_required: false,
    option_choices: null,
    default_value: null,
    ui_extract_class: null,
    ui_data_resolver_method: null,
    evaluator_extract_class: 'av_rule.api.AVMeetingRuleEvaluatorApi',
    evaluator_method: 'evaluate_recording_duration',
    api_url: null,
    order: 7,
    filter_data: {
      Meeting: {
        field_lookup: null,
        filter_class_path:
          'av_rule.filters.custom_filters.RecordingDurationFilter',
        pg_supported: true
      },
      Call: {
        field_lookup: null,
        filter_class_path:
          'av_rule.filters.custom_filters.RecordingDurationFilter',
        pg_supported: true
      },
      Conversation: {
        field_lookup: null,
        filter_class_path:
          'av_rule.filters.custom_filters.RecordingDurationFilter',
        pg_supported: true
      }
    }
  },
  {
    label: 'Deal stage now',
    description: 'Deal stage now',
    uid: 'deal_stage_now',
    operators: ['in', 'not_in'],
    field_type: 'multi_select',
    django_field_type: 'string',
    is_required: false,
    option_choices: null,
    default_value: null,
    ui_extract_class: 'av_rule.api.AvomaRuleUiApi',
    ui_data_resolver_method: 'get_deal_stage_now',
    evaluator_extract_class: 'av_rule.api.AVMeetingRuleEvaluatorApi',
    evaluator_method: 'evaluate_deal_stage_now_by_id',
    api_url: 'av_rules/get_deal_stage_now',
    order: 9,
    filter_data: {
      Meeting: {
        field_lookup: null,
        filter_class_path: null,
        pg_supported: false
      },
      Call: {
        field_lookup: null,
        filter_class_path: null,
        pg_supported: false
      },
      Deal: {
        field_lookup: null,
        filter_class_path: 'av_rule.filters.custom_filters.DealStageFilter',
        pg_supported: true
      },
      Conversation: {
        field_lookup: null,
        filter_class_path: null,
        pg_supported: false
      }
    }
  }
];
